<mat-card class="filter settingHeader">
  <div class="name">
    Manage Integration
  </div>
  <div class="quickAction">
    
    <mat-form-field appearance="" >
      <mat-label>Search items in Integration</mat-label>
      <input matInput type="text"  maxlength="30" >
      <button mat-button  matSuffix mat-icon-button aria-label="Clear" >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <div class="addbtn">
      <button mat-flat-button color="primary" (click)="addFolder(addFolderDialog)">Add Integration</button>
    </div>

  </div>
</mat-card>



<div class="documents">
    
  
    <mat-card class="example-list rowholder">
      <div class="fieldRow head">
        <span class="moveicon"></span>
        <span class="fieldName">Name</span>  
        <span class="delete">Edit</span>   
        <span class="delete">Delete</span>
      </div>
      <div class="example-box fieldRow">
        <div class="moveicon"></div>
        <span class="fieldName">Integration 1</span>     
        <span class="delete">
            <button mat-icon-button class="trash" >
              <mat-icon>create</mat-icon>
            </button>
          </span>
        <span class="delete">
          <button mat-icon-button class="trash" >
            <mat-icon>delete_outline</mat-icon>
          </button>
        </span>
      </div>
      <!-- <mat-paginator [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons [length]="paginatorTotalLength" (page)="CallNextPrevPageData($event)"></mat-paginator>
      -->
    </mat-card>
</div>
  



<ng-template #addFolderDialog>
    <h2 matDialogTitle>Add Integration</h2>
    <mat-dialog-content>
  
      <form>
  
        <mat-radio-group aria-label="" class="selectNote" >
          <mat-radio-button color="primary" value="1">Core</mat-radio-button>
          <mat-radio-button  color="primary" value="2">Contact</mat-radio-button>
          <mat-radio-button  color="primary" value="2">Company</mat-radio-button>
        </mat-radio-group>
  
        <mat-form-field>
          <mat-label>Select Sub Type</mat-label>
        <mat-select>                
          <mat-option value="1">All</mat-option>
          <mat-option value="2">Doctor</mat-option>
        </mat-select>
      </mat-form-field>
        
      <div class="tdata">
        <div class="rowholder">
          <div class="fieldRow head">
            <span class="moveicon"></span>
            <span class="fieldIcon"></span>
            <span class="fieldName">Name</span>

            <span class="fieldControl">Field Control Type</span>     
            <span class="fieldType">Field Type</span>
            <span class="requried">Requried</span>
            <span class="mapping">Mapping</span>
            <span class="key">Key</span>
            <span class="delete">Action</span>
          </div>
          <div class="example-box">
            <div class="fieldRow" >
              <span class="moveicon">
                <mat-icon>drag_handle</mat-icon>
              </span>
              <span class="fieldIcon">
                <mat-icon>assignment</mat-icon>
              </span>
              <span class="fieldName">Type</span>
              <span class="fieldControl">Textbox</span>       
              <span class="fieldType">         
                <mat-icon matTooltipClass="tooltip"  matTooltip="Global">public
                </mat-icon>
           
              </span>
      
      
              <span class="requried" >
                <mat-slide-toggle color="primary" [checked]=true>
                </mat-slide-toggle>
              </span>
  
      
              <span class="mapping">
                <mat-form-field class="example-full-width">
                  <mat-label>Mapping Name</mat-label>
                  <input matInput placeholder="Add Mapping Name" value="">
                </mat-form-field>
              </span>
  
              <span class="key">
                Key Name
              </span>
      
              <span class="delete">
                <button mat-icon-button class="trash" >
                  <mat-icon>remove_circle_outline</mat-icon>
                </button>
              </span>
      
            </div>
          </div>
          
          <div class="example-box">
            <div class="fieldRow" >
              <span class="moveicon">
                <mat-icon>drag_handle</mat-icon>
              </span>
              <span class="fieldIcon">
                <mat-icon>assignment</mat-icon>
              </span>
              <span class="fieldName">Name</span>
              <span class="fieldControl">Textbox</span>       
              <span class="fieldType">         
                <mat-icon matTooltipClass="tooltip"  matTooltip="Global">public
                </mat-icon>
           
              </span>
      
      
              <span class="requried" >
                <mat-slide-toggle color="primary" [checked]=false>
                </mat-slide-toggle>
              </span>
  
      
              <span class="mapping">
                <mat-form-field class="example-full-width">
                  <mat-label>Mapping Name</mat-label>
                  <input matInput placeholder="Add Mapping Name" value="">
                </mat-form-field>
              </span>
  
              <span class="key">
                Key Name
              </span>
      
              <span class="delete">
                <button mat-icon-button class="trash" >
                  <mat-icon>remove_circle_outline</mat-icon>
                </button>
              </span>
      
            </div>
          </div>
          


        </div>
      </div>
      
      
      </form>
  
    </mat-dialog-content>
    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" >Cancel</button>
      <button mat-button color="primary" >Add</button>
    </mat-dialog-actions>
  </ng-template>
  